import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

const collator = new Intl.Collator("pt-BR", {
  numeric: true,
  sensitivity: "base",
})

/** Ordenação natural: números em ordem crescente e textos em ordem alfabética. */
export function compararTexto(a: string, b: string) {
  return collator.compare(a.trim(), b.trim())
}

/** Normaliza texto para busca (sem acento e sem diferenciar maiúsculas). */
export function normalizarBusca(texto: string) {
  return texto
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim()
}
